export const showModal = (modalName) => (state, action) => {
  state[modalName] = {
    show: true,
    ...action.payload,
  }
}

export const hideModal = (modalName, initialState) => (state, action) => {
  state[modalName] = {
    show: false,
    ...initialState,
  }
}
